/**
 * Shopify Theme JavaScript - Branch Version with JSON Support
 * This file runs automatically on all pages
 * 
 * Product Data Structure:
 * The code now reads from Shopify's product JSON instead of hidden fields.
 * 
 * To expose product JSON in your theme, add this to your product template:
 * <script id="ProductJson-{{ section.id }}" type="application/json">
 *   {{ product | json }}
 * </script>
 * 
 * Or expose it globally:
 * <script>
 *   window.product = {{ product | json }};
 * </script>
 * 
 * The code will automatically fallback to hidden fields if JSON data is not available.
 */

(function() {
  'use strict';

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.SPID.initOnReady);
  } else {
    window.SPID.initOnReady();
  }


})();
